import { ProjectValidationUnit, ValidationItem } from '../../../../../models/data-structures/project-validation';
import {
  FeedstockBmpCurve,
  FeedstockBmpCurvePropName
} from '../../../../../models/project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-curve.model';
import { ValidationInterface } from '../../../validation.interface';
import { UnitValueValidation } from '../../unit-value.validation';

export class FeedstockBmpCurveValidation implements ValidationInterface {

  bmpCurve: FeedstockBmpCurve;

  constructor(bmpCurve: FeedstockBmpCurve) {
    if (!bmpCurve) {
      throw Error('invalid BMP potential direct provided for validation');
    }
    this.bmpCurve = new FeedstockBmpCurve(bmpCurve);
  }

  getValidation(validationUnit = new ProjectValidationUnit()): ProjectValidationUnit {
    if (!this.bmpCurve) {
      throw Error('unable to validate BMP potential direct');
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpCurve.ch4Concentration).getValidation(),
      FeedstockBmpCurvePropName.ch4Concentration
    );

    if (this.bmpCurve.bmp == null) {
      validationUnit.setInvalid(FeedstockBmpCurvePropName.bmp, ['unit is missing']);
    } else {
      validationUnit.setValid(FeedstockBmpCurvePropName.bmp);
    }

    if (this.bmpCurve.hrt == null) {
      validationUnit.setInvalid(FeedstockBmpCurvePropName.hrt, ['unit is missing']);
    } else {
      validationUnit.setValid(FeedstockBmpCurvePropName.hrt);
    }

    if (this.bmpCurve.curve && this.bmpCurve.curve.length < 1) {
      const errMsgs = ['at least one entry is required'];
      validationUnit.isValid = false;
      validationUnit.invalidFields += 2;
      if (!(validationUnit.tree instanceof ValidationItem)) {
        validationUnit.tree[FeedstockBmpCurvePropName.curve] = new ValidationItem(false, FeedstockBmpCurvePropName.curve, errMsgs);
      }
    }

    return validationUnit;
  }

  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
